import { Role } from '../../../../types/auth';

export const getData = (t: (key: string) => string) => [
  {
    title: t('pages:admin.tenants'),
    path: '',
    permissions: [Role.SuperAdmin],
  },
];

// Para compatibilidad con imports existentes
export const data = [
  {
    title: 'Tenants',
    path: '',
    permissions: [Role.SuperAdmin],
  },
];
